import React, { Component } from 'react';
import './unsplash-picker.css';
import Unsplash, { toJson } from 'unsplash-js';
import Gallery from 'react-photo-gallery';
import SelectedImage from './SelectedImage'; 
import Waypoint from 'react-waypoint';
import debounce from 'lodash/debounce';
import findIndex from 'lodash/findIndex';
import {Loader, Modal, Button} from 'semantic-ui-react';  


export default class UnsplashPicker extends Component {

    constructor(props){
      super(props);
      
      this.state = {
        photos : [], 
        pictures : [],
        input : '',
        pages_counter : 1, 
        open: false
      }
      this.updateInput = this.updateInput.bind(this);
      this.selectPhoto = this.selectPhoto.bind(this);
      this.loadMoreContent = this.loadMoreContent.bind(this); 
      this.renderWaypoint = this.renderWaypoint.bind(this); 
      this.validate = this.validate.bind(this); 
    }

    componentWillMount() {
      this.delayedCallback = debounce(function (event) {
        this.setState({input : event.target.value});
        this.fetchSearchResults(this.state.input);
      }, 1000);
    }

    updateInput = (event)=>{
      event.persist(); 
      this.delayedCallback(event);
    } 

    async fetchSearchResults(keyword) {
      this.unsplash = await new Unsplash({
        applicationId: "ff89fd0ea45d947c73cc10f4fcab40eb0f630e8666d3b850f6078704df4eeb6c",
        secret: "7a1f432cea1f859cbe91081b65f4f435eb1d8b923bbdbc7762c7310a01c1502b",
        callbackUrl: "urn:ietf:wg:oauth:2.0:oob"
      });

      this.unsplash.search.photos(keyword, 1,30)
        .then(toJson)
        .then(json => { 
          const photos = json.results; 
          const pictures = photos.map(photo => ({
            key : photo.id, 
            selected : false,
            src: photo.urls.small, 
            download : photo.links.download_location,
            author : photo.user.name,
            username : photo.user.username, 
            width : Math.trunc(photo.width/1000), 
            height: Math.trunc(photo.height/1000)
          })); 
            this.setState({photos, pictures}); 
        });
    }

    async showMoreResults(keyword, page) {
      this.unsplash.search.photos(keyword, page, 30)
        .then(toJson)
        .then(json => { 
          const newPhotos = json.results; 
          const newPictures = newPhotos.map(photo => ({
            key : photo.id, 
            src: photo.urls.small,
            selected : false, 
            download : photo.links.download_location,  
            author : photo.user.name,
            username : photo.user.username, 
            width : Math.trunc(photo.width/1000) , 
            height: Math.trunc(photo.height/1000)
          }))
          const photos = [...this.state.photos, ...newPhotos]
          const pictures = [...this.state.pictures, ...newPictures]
            this.setState({photos, pictures}); 
        });
    }

    selectPhoto(event, obj) {
        let photos = this.state.pictures;
        photos = photos.map((p, index) => {
          if (p.selected) return {...p, selected: false}
          else if (index === obj.index) return {...p, selected: !p.selected}
          return p
        })
        this.setState({ pictures: photos });
    }

    loadMoreContent() {
      let pictures = this.state.pictures;
      if (pictures.length!==0)
      {
        this.setState({pages_counter: this.state.pages_counter+1});  
        this.showMoreResults(this.state.input,this.state.pages_counter); 
      }
    }

    renderWaypoint() {
      let pictures = this.state.pictures;
      if (pictures.length!==0) {
        return (
          <div>
          <Waypoint
            onEnter={this.loadMoreContent}
          />
          <Loader active inline="centered" />
          </div>
        );
      }
    }

    show = dimmer => (e) => {
      e.preventDefault()
      e.stopPropagation()
      this.setState({ open: true })
    }
    close = () => this.setState({ open: false })

    validate() {
      const index = findIndex(this.state.pictures, p => p.selected)
    
      if (index >= 0){
        const photo = this.state.photos[index]
        this.unsplash.photos.downloadPhoto(photo);
        
        const { onSelect } = this.props
        if (onSelect){
          onSelect({
            uri: photo.urls.regular
          })
          this.setState({ open: false })
        }
      }
    }

    render() {
        let disable = true; 
        this.state.pictures.map((p) => {
          if (p.selected) return disable = false;  
          return disable; 
        }); 

        const { open } = this.state; 
        return (
        <div style={{paddingTop: 8}}>
          <Button onClick={this.show(true)}>Sélectionner une photo</Button>
          <Modal dimmer='inverted' open={open} onClose={this.close} size="large">
            <Modal.Header>
              <div>
                Photos by <a target="_blank" href="https://unsplash.com/?utm_source=appcraft_events&utm_medium=referral">Unsplash</a>
                <input type="search" autoFocus className="search--unsplash" placeholder="Chercher..." value={this.state.updateInput} onChange={this.updateInput } onKeyDown={this.search}></input>
              </div>
            </Modal.Header>
            <Modal.Content style={{maxHeight: '70vh', minHeight: '70vh', overflowY: 'scroll'}}>
              <Modal.Description>
                <Gallery columns={4} photos={this.state.pictures} onClick={this.selectPhoto} ImageComponent={SelectedImage} />
                <div>
                  {this.renderWaypoint()}  
                </div>
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              <Button color='black' onClick={this.close}>
                Annuler
              </Button>
              <Button positive icon='checkmark' labelPosition='right' content="Valider" disabled={disable} onClick={this.validate} />
            </Modal.Actions>
          </Modal>
        </div>
      );
    }
}



// WEBPACK FOOTER //
// ./src/components/UnsplashPicker/index.js